import { Button, CheckList, Empty, Input, Popup, SearchBar, SearchBarRef } from 'antd-mobile';
import { isEmpty } from 'lodash-es';
import NoData from '@/assets/images/noData.png';
import styles from './index.module.scss';
import { GetAreaListPostResponse } from '@/api/energy';
import { useMemo, useRef, useState } from 'react';

interface SelectAreaProps {
  onCancel: () => void;
  onOk: (params: number[]) => void;
  visible?: boolean;
  data?: GetAreaListPostResponse[];
  value?: number[];
}

const SelectArea = ({ onCancel, onOk, data, value, visible }: SelectAreaProps) => {
  const [searchAreaText, setSearchAreaText] = useState('');
  const [selectedArea, setSelectedArea] = useState<number[]>(value || []);

  const searchAreaRef = useRef<SearchBarRef>(null);

  const filteredAreaItems = useMemo(() => {
    if (searchAreaText) {
      return data!.filter(item => item.zoneName!.includes(searchAreaText));
    } else {
      return data;
    }
  }, [data, searchAreaText]);

  const selectedAreaLabel = useMemo(() => {
    return (value ?? []).map(item => {
      return (data ?? [])?.find(i => i.id === item)?.zoneName;
    });
  }, [value, data]);

  return (
    <>
      {visible && (
        <Popup visible={visible} closeOnMaskClick onClose={onCancel} position="bottom" className="actionMenu">
          <div className={styles.popupTitleContainer}>
            <Button size="small" color="primary" fill="none" onClick={onCancel}>
              取消
            </Button>
            <Button size="small" color="primary" fill="none" onClick={() => onOk(selectedArea)}>
              确定
            </Button>
          </div>
          <div className={styles.popupContainer}>
            <SearchBar placeholder="请输入" ref={searchAreaRef} onChange={setSearchAreaText} />

            <div className={styles.areaList}>
              {!isEmpty(filteredAreaItems) ? (
                <CheckList
                  multiple
                  value={selectedArea}
                  onChange={val => {
                    setSelectedArea(val as number[]);
                  }}
                >
                  {filteredAreaItems?.map(item => (
                    <CheckList.Item key={item.id} value={item.id!}>
                      {item.zoneName}
                    </CheckList.Item>
                  ))}
                </CheckList>
              ) : (
                <div className={styles.emptyState}>
                  <Empty image={NoData} description={'暂无数据'} />
                </div>
              )}
            </div>
          </div>
        </Popup>
      )}
      <Input value={selectedAreaLabel.join(',')} placeholder="请选择区域" className="ellipsisInput"></Input>
    </>
  );
};

export default SelectArea;
